'use strict';

var _slicedToArray = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var promisify = require('promisify-es6');

var waterfall = require('async/waterfall');

var parallel = require('async/parallel');

var _require = require('./utils'),
    createLock = _require.createLock,
    updateMfsRoot = _require.updateMfsRoot,
    validatePath = _require.validatePath,
    traverseTo = _require.traverseTo,
    addLink = _require.addLink,
    updateTree = _require.updateTree,
    toPullSource = _require.toPullSource,
    loadNode = _require.loadNode,
    limitStreamBytes = _require.limitStreamBytes,
    countStreamBytes = _require.countStreamBytes,
    zeros = _require.zeros;

var _require2 = require('ipfs-unixfs'),
    unmarshal = _require2.unmarshal;

var pull = require('pull-stream/pull');

var cat = require('pull-cat');

var collect = require('pull-stream/sinks/collect');

var empty = require('pull-stream/sources/empty');

var err = require('pull-stream/sources/error');

var log = require('debug')('ipfs:mfs:write');

var values = require('pull-stream/sources/values');

var _require3 = require('ipfs-unixfs-engine'),
    exporter = _require3.exporter,
    importer = _require3.importer;

var deferred = require('pull-defer');

var CID = require('cids');

var defaultOptions = {
  offset: 0,
  // the offset in the file to begin writing
  length: undefined,
  // how many bytes from the incoming buffer to write
  create: false,
  // whether to create the file if it does not exist
  truncate: false,
  // whether to truncate the file first
  rawLeaves: false,
  reduceSingleLeafToSelf: false,
  cidVersion: 0,
  hashAlg: 'sha2-256',
  format: 'dag-pb',
  parents: false,
  // whether to create intermediate directories if they do not exist
  progress: undefined,
  strategy: 'trickle',
  flush: true,
  leafType: 'raw'
};

module.exports = function mfsWrite(ipfs) {
  return promisify(function (path, content, options, callback) {
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    options = Object.assign({}, defaultOptions, options);

    if (options.offset < 0) {
      return callback(new Error('cannot have negative write offset'));
    }

    if (options.length < 0) {
      return callback(new Error('cannot have negative byte count'));
    }

    if (!options.length && options.length !== 0) {
      options.length = Infinity;
    }

    options.cidVersion = options.cidVersion || 0;
    waterfall([function (done) {
      parallel([function (next) {
        return toPullSource(content, options, next);
      }, function (next) {
        return validatePath(path, next);
      }], done);
    }, // walk the mfs tree to the containing folder node
    function (_ref, done) {
      var _ref2 = _slicedToArray(_ref, 2),
          source = _ref2[0],
          path = _ref2[1];

      waterfall([function (next) {
        var opts = Object.assign({}, options, {
          createLastComponent: options.parents
        });

        if (opts.createLastComponent) {
          createLock().writeLock(function (callback) {
            traverseTo(ipfs, path.directory, opts, function (error, result) {
              return callback(error, {
                source: source,
                containingFolder: result
              });
            });
          })(next);
        } else {
          createLock().readLock(function (callback) {
            traverseTo(ipfs, path.directory, opts, function (error, result) {
              return callback(error, {
                source: source,
                containingFolder: result
              });
            });
          })(next);
        }
      }, function (_ref3, next) {
        var source = _ref3.source,
            containingFolder = _ref3.containingFolder;
        updateOrImport(ipfs, options, path, source, containingFolder, next);
      }], done);
    }], function (error) {
      return callback(error);
    });
  });
};

var updateOrImport = function updateOrImport(ipfs, options, path, source, containingFolder, callback) {
  waterfall([function (next) {
    var existingChild = containingFolder.node.links.reduce(function (last, child) {
      if (child.name === path.name) {
        return child;
      }

      return last;
    }, null);

    if (existingChild) {
      return loadNode(ipfs, existingChild, next);
    }

    if (!options.create) {
      return next(new Error('file does not exist'));
    }

    next(null, null);
  }, function (existingChild, next) {
    write(ipfs, existingChild, source, options, next);
  }, // The slow bit is done, now add or replace the DAGLink in the containing directory
  // re-reading the path to the containing folder in case it has changed in the interim
  function (child, next) {
    createLock().writeLock(function (callback) {
      var opts = Object.assign({}, options, {
        createLastComponent: options.parents
      });
      traverseTo(ipfs, path.directory, opts, function (error, containingFolder) {
        if (error) {
          return callback(error);
        }

        waterfall([function (next) {
          addLink(ipfs, {
            parent: containingFolder.node,
            name: path.name,
            child: {
              multihash: child.multihash || child.hash,
              size: child.size
            },
            flush: options.flush
          }, function (error, newContaingFolder) {
            // Store new containing folder CID
            containingFolder.node = newContaingFolder;
            next(error);
          });
        }, // Update the MFS tree from the containingFolder upwards
        function (next) {
          return updateTree(ipfs, containingFolder, next);
        }, // Update the MFS record with the new CID for the root of the tree
        function (newRoot, next) {
          return updateMfsRoot(ipfs, newRoot.node.multihash, next);
        }], function (error, result) {
          callback(error, result);
        });
      });
    })(next);
  }], callback);
};

var write = function write(ipfs, existingNode, source, options, callback) {
  var existingNodeCid;
  var existingNodeMeta;

  if (existingNode) {
    existingNodeCid = new CID(existingNode.multihash);
    existingNodeMeta = unmarshal(existingNode.data);
    log("Overwriting file ".concat(existingNodeCid.toBaseEncodedString(), " offset ").concat(options.offset, " length ").concat(options.length));
  } else {
    log("Writing file offset ".concat(options.offset, " length ").concat(options.length));
  }

  var sources = []; // pad start of file if necessary

  if (options.offset > 0) {
    if (existingNode && existingNodeMeta.fileSize() > options.offset) {
      log("Writing first ".concat(options.offset, " bytes of original file"));
      var startFile = deferred.source();
      sources.push(startFile);
      pull(exporter(existingNodeCid, ipfs.dag, {
        offset: 0,
        length: options.offset
      }), collect(function (error, files) {
        if (error) {
          return startFile.resolve(err(error));
        }

        startFile.resolve(files[0].content);
      }));
    } else {
      log("Writing zeros for first ".concat(options.offset, " bytes"));
      sources.push(zeros(options.offset));
    }
  }

  var endFile = deferred.source(); // add the new source

  sources.push(pull(source, limitStreamBytes(options.length), countStreamBytes(function (bytesRead) {
    log("Wrote ".concat(bytesRead, " bytes"));

    if (existingNode && !options.truncate) {
      // if we've done reading from the new source and we are not going
      // to truncate the file, add the end of the existing file to the output
      var fileSize = existingNodeMeta.fileSize();
      var offset = options.offset + bytesRead;

      if (fileSize > offset) {
        log("Writing last ".concat(fileSize - offset, " of ").concat(fileSize, " bytes from original file"));
        pull(exporter(existingNodeCid, ipfs.dag, {
          offset: offset
        }), collect(function (error, files) {
          if (error) {
            return endFile.resolve(err(error));
          }

          endFile.resolve(files[0].content);
        }));
      } else {
        log("Not writing last bytes from original file");
        endFile.resolve(empty());
      }
    }
  }))); // add the end of the file if necessary

  if (existingNode && !options.truncate) {
    sources.push(endFile);
  }

  pull(values([{
    path: '',
    content: cat(sources)
  }]), importer(ipfs.dag, {
    progress: options.progress,
    hashAlg: options.hash,
    cidVersion: options.cidVersion,
    strategy: options.strategy,
    rawLeaves: options.rawLeaves,
    reduceSingleLeafToSelf: options.reduceSingleLeafToSelf,
    leafType: options.leafType
  }), collect(function (error, results) {
    if (error) {
      return callback(error);
    }

    var result = results.pop();
    log("Wrote ".concat(new CID(result.multihash).toBaseEncodedString()));
    callback(null, result);
  }));
};